import React from "react";
import { Plus, X } from "lucide-react";

// Matches MAX_ADDITIONAL_EMAILS on the backend.
export const MAX_EXTRA_EMAILS = 5;

/** Trim, lowercase, drop blanks and repeats: the list as the server keeps it. */
export function cleanExtraEmails(emails) {
  const cleaned = [];
  for (const raw of emails || []) {
    const email = (raw || "").trim().toLowerCase();
    if (email && !cleaned.includes(email)) cleaned.push(email);
  }
  return cleaned;
}

/**
 * Extra family contact emails (mum, dad, grandma) that the club copies on
 * its emails. Used by the parent's settings and the admin parent form.
 */
export default function ExtraEmailsField({
  value,
  onChange,
  disabled = false,
  inputClassName = "",
}) {
  const emails = value || [];

  const update = (index, email) =>
    onChange(emails.map((e, i) => (i === index ? email : e)));
  const remove = (index) => onChange(emails.filter((_, i) => i !== index));

  return (
    <div className="space-y-2">
      {emails.map((email, index) => (
        <div key={index} className="flex items-center gap-2">
          <input
            type="email"
            aria-label={`Extra contact email ${index + 1}`}
            value={email}
            onChange={(e) => update(index, e.target.value)}
            disabled={disabled}
            placeholder="name@example.com"
            className={inputClassName}
          />
          <button
            type="button"
            onClick={() => remove(index)}
            disabled={disabled}
            aria-label={`Remove ${email || "this email"}`}
            className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-red-600 disabled:opacity-50"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
      {emails.length < MAX_EXTRA_EMAILS && (
        <button
          type="button"
          onClick={() => onChange([...emails, ""])}
          disabled={disabled}
          className="flex items-center gap-1 text-sm font-medium text-[#173151] hover:underline disabled:opacity-50"
        >
          <Plus className="w-4 h-4" /> Add email
        </button>
      )}
    </div>
  );
}
